<template>
  <Modal
      v-model="_value"
      width="500"
      title="追加备注"
      @on-visible-change="visibleChange"
      ok-text="确认追加"
      @on-ok="onOk"
      cancel-text="关闭">
    <Form :model="stopSimCardDataResult" style="display: inline;">
      <FormItem prop="result">
        <label style="display: inline-block; width: 60px;">备注</label>
        <Input style="display: inline-block; width: 400px;" type="textarea"
               v-model="stopSimCardDataResult.processRemark" placeholder="备注">
        </Input>
      </FormItem>
    </Form>
  </Modal>
</template>
<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

export default {
  name: 'stopsimcardaddremarkmodal',
  props: {
    value: {
      type: Boolean,
      default: false
    },
    initValue: null
  },
  data () {
    return {
      stopSimCardDataResult: {
        id: null,
        processRemark: null
      }
    }
  },
  methods: {
    ...mapActions([
      'StopSimCardDataAnalysisResultServ_AddProcessRemark',
      'get_StopSimCardDataAnalysisResult_GetDetailResult'
    ]),
    onOk () {
      this.$Modal.confirm({
        title: '提示',
        content: '<p>确认追加备注</p>',
        onOk: () => {
          store.dispatch('StopSimCardDataAnalysisResultServ_AddProcessRemark', {
            params: this.stopSimCardDataResult
          }).then(() => {
            this.$Message.success('追加成功')
            this.$emit('on-success')
          }).catch(err => {
            this.$Message.error(err)
            this.$emit('on-fail')
          })
        },
        onCancel: () => {

        }
      })
    },
    visibleChange (val) {
      if (val) {
        this.stopSimCardDataResult.id = null
        this.stopSimCardDataResult.processRemark = null
        let id = this._initValue
        if (id) {
          store.dispatch('StopSimCardDataAnalysisResultServ_GetDetail', {
            params: { id: this._initValue }
          }).then(() => {
            this.stopSimCardDataResult = store.getters.get_StopSimCardDataAnalysisResult_GetDetailResult
          }).catch(err => {
            this.$Message.error(err)
          })
        }
      }
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
